import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { loginMember } from "@/api/authApi"; // 💡 아까 공유해주신 API 경로에 맞게 수정

export default function LoginModal({ redirectPath }: { redirectPath: string | null }) {
  const navigate = useNavigate();
  const { closeLoginModal, refreshAuth } = useAuth();

  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      // 1. API 호출
      await loginMember({ loginId, password });

      // 2. 유저 정보 갱신
      await refreshAuth();

      // 3. 모달 닫기
      closeLoginModal();

      // 4. 원래 가려던 곳이 있으면 그곳으로 이동!
      if (redirectPath) {
        navigate(redirectPath);
      }
    } catch (error: any) {
      setErrorMsg(error.response?.data?.message || "아이디 또는 비밀번호를 확인해주세요.");
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-[28px] bg-white p-8 shadow-2xl">
        <div className="mb-6 flex items-center justify-between">
          <h2 className="text-2xl font-black text-slate-800">로그인</h2>
          <button onClick={closeLoginModal} className="text-2xl text-slate-400 hover:text-slate-700">&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              placeholder="아이디"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              className="h-12 w-full rounded-xl border border-slate-300 px-4 focus:border-slate-800 focus:outline-none focus:ring-1 focus:ring-slate-800"
            />
          </div>
          <div>
            <input
              type="password"
              placeholder="비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 w-full rounded-xl border border-slate-300 px-4 focus:border-slate-800 focus:outline-none focus:ring-1 focus:ring-slate-800"
            />
          </div>

          {errorMsg && <p className="text-sm font-bold text-rose-500">{errorMsg}</p>}

          <button
            type="submit"
            className="mt-4 h-12 w-full rounded-xl bg-slate-900 text-base font-bold text-white hover:bg-slate-800"
          >
            로그인
          </button>
        </form>
      </div>
    </div>
  );
}